/**
 * @file 首页
 * @author wangzhuang
 */

import {rcAjax} from '../util';
import {
    GET_CREATE_TOPIC
} from './ActionTypes';

export function fetchCreateTopic(dispatch, params) {
    return rcAjax('POST', '/api/v1/feedback/createTopic', {}, params, data => {
        dispatch({type: GET_CREATE_TOPIC, data: data.data});
    });
}